<div fxLayout="row" fxLayoutAlign="center start" class="submission-wrapper">
  <mat-card fxFlex="700px" class="mat-elevation-z8">
    <form
      [formGroup]="form"
      *ngIf="form"
      fxLayout="row wrap"

    >
      <p *ngIf="universityId==77"
       class="umainMsg">Campus Channel ads promoting an in-person gathering must be approved
        through the event management process before being displayed. Learn more
        at <a
        target="_blank"
        href="https://umaine.edu/plan-an-event"
        aria-label="plan an event">umaine.edu/plan-an-event</a>.</p>
      <ng-container *ngFor="let section of form.controls; let i = index">
        <h1 *ngIf="section.get('name').value" role="heading" fxFlex="100%">
          {{ i + 1 }}. {{ section.get('name').value }}
        </h1>
        <ng-container *ngFor="let field of section.get('fields').controls">
          
          <ng-container *ngIf="field.get('isVisible').value">
            <ng-container
              *ngTemplateOutlet="formTemplate; context: { field: field }"
            ></ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
      <div
        class="form-actions"
        fxFlex="100%"
        fxLayoutAlign="end start"
        fxLayoutGap="25px"
      >
        <button
          mat-stroked-button
          fxFlex="140px"
          (click)="resetForm()"
          aria-label="Reset Form"
        >
          <mat-icon>refresh</mat-icon>
          Reset
        </button>
        <button
          id="btn_submit"
          mat-raised-button
          class="primary"
          fxFlex="140px"
          (click)="saveForm()"
          aria-label="Submit to process Ad data, wait for dialog to pop up"
        >
          <mat-icon>publish</mat-icon>
          Submit
        </button>
          <div *ngIf="showErrors"
          class="mat-error submit-errors"
           aria-label="form errors"
           tabindex="0"
           >
            <mat-icon>error</mat-icon> The following fields are not valid:
            {{invalidControls}}
            <p *ngIf="captchaTandCError">Please check captcha and  agreed terms and conditions</p>
          </div>
      </div>
      <div><p>
        For content related support,  please contact <a href="mailto:ces-content@apogee.us" target="_blank">ces-content@apogee.us</a>
        <br>
        For technical or other support, please contact <a href="mailto:ces-support@apogee.us" target="_blank">ces-support@apogee.us</a>
      </p></div>
    </form>
    <div
      class="loader"
      *ngIf="loading"
      fxFlex="100%"
      fxLayoutAlign="center center"
    >
      <mat-spinner diameter="60"></mat-spinner>
    </div>
    <portal-wrong *ngIf="error && !loading" fxFlex="100%"></portal-wrong>
  </mat-card>
</div>

<!-- FORM TEMPLATE -->
<ng-template #formTemplate let-field="field">
  <div
    fxFlex="100%"
    [ngSwitch]="field.get('field_type').value"
    *ngIf="conditionalEnabled(field)"
  >
    <ng-container *ngSwitchCase="FieldType.TextField">
      <portal-input
        fxFlex
        [form]="field"
        controlName="value"
        [label]="field.get('name').value"
        [placeholder]="
          field.get('placeholder')?.value || field.get('name').value
        "
        [icon]="field.get('icon').value"
        [customErrors]="customErrors"
        [hintEnd]="
          FieldType.TextField && field.get('name').value === 'File URL'
            ? 'The following file types are supported: .ppt .swf, .wmv, .mov, .mpeg, .jpeg, .pdf, .bmp, .png. File size must be less than 20MB; files greater than 20MB in size should be uploaded to YouTube.'
            : FieldType.TextField && field.get('name').value === 'Description'
              ?'Enter a short description of your ad. This description will not appear on screen when the ad is displayed.'
              : null
        "
        [readonly]="fileURLEditable(field.get('name').value)"
        [ngClass]="{'spaceAtBottom': (FieldType.TextField && field.get('name').value === 'File URL')}"
      ></portal-input>
      <portal-input-file
        icon="search"
        *ngIf="FieldType.TextField && field.get('name').value === 'File URL'"
        [disabled]="!fileURLEditable(field.get('name').value)"
        [loading]="fileLoading"
        [maxSize]="20000000"
        [accept]="fileAccept"
        (fileChange)="uploadFile($event, field)"
      ></portal-input-file>
    </ng-container>
    <div *ngSwitchCase="FieldType.Select">

      <div *ngIf="isAdmin; else templateAffiliation">
        <div *ngIf="field.get('name').value!=='Affiliation Type'">
          <portal-select
          *ngIf="field"
          fxFlex
          [label]="field.get('name').value"
          [placeholder]="
            field.get('placeholder')?.value || field.get('name').value"
          [value]="getSelectValue(field.get('options'))"
          [options]="getOptions(field.get('name').value)"
          [icon]="field.get('icon').value"
          [required]="field"
          [isFilterBy]="false"
          (selectionChange)="selectValueChange($event, field.get('options'))"
        ></portal-select>
        <p
          class="errors"
          fxFlex="100%"
          fxLayout="row"
          fxLayoutAlign="start center"
          *ngIf="displayError(field) && field.dirty && field.touched"
        >
          <mat-icon>error</mat-icon>
          {{ displayError(field) }}
        </p>
        </div>
      </div>

      <ng-template #templateAffiliation>
        <portal-select
        *ngIf="field"
        fxFlex
        [label]="field.get('name').value"
        [placeholder]="
          field.get('placeholder')?.value || field.get('name').value
        "
        [value]="getSelectValue(field.get('options'))"
        [options]="getOptions(field.get('name').value)"
        [icon]="field.get('icon').value"
        [required]="field"
        [isFilterBy]="false"
        (selectionChange)="selectValueChange($event, field.get('options'))"
      ></portal-select>
      <p
        class="errors"
        fxFlex="100%"
        fxLayout="row"
        fxLayoutAlign="start center"
        *ngIf="displayError(field) && field.dirty && field.touched"
      >
        <mat-icon>error</mat-icon>
        {{ displayError(field) }}
      </p>
      </ng-template>

    </div>
    <div fxFlex *ngSwitchCase="FieldType.Checkbox" class="checkbox-group">
      <fieldset
        fxFlex="100%"
        fxLayout="column"
        *ngIf="!!field"
        role="group"
        tabindex="0"
        [attr.aria-label]="field.get('name').value + ' group'"
      >
        <legend fxLayoutAlign="start center">
          <mat-icon *ngIf="field.get('icon')">{{
            field.get('icon').value
          }}</mat-icon>
          {{ field.get('name').value }}
          <span aria-hidden="true" [style.color]="'gray'">{{
            field.errors && field.errors?.required && ' *'
          }}</span>
        </legend>
        <div fxLayout="row wrap">
          <ng-container *ngIf="!field.errors">
            <mat-checkbox
              [attr.aria-label]="field.get('name').value + ' options'"
              fxFlex="100%"
              *ngFor="
                let option of getOptions(field.get('name').value);
                let i = index
              "
              [checked]="getSelectedItems(field.get('options'), i)"
              (change)="checkboxValueChange($event, field, i, false)"
              >{{ option.label }}
            </mat-checkbox>
          </ng-container>
          <!-- Need it this way for screen readers D: -->
          <ng-container *ngIf="field.errors && field.errors?.required">
            <mat-checkbox
              [attr.aria-label]="field.get('name').value + ' options'"
              fxFlex="100%"
              *ngFor="
                let option of getOptions(field.get('name').value);
                let i = index
              "
              [checked]="getSelectedItems(field.get('options'), i)"
              (change)="checkboxValueChange($event, field, i, false)"
              required
              >{{ option.label }}
            </mat-checkbox>
          </ng-container>
        </div>
        <p
          class="errors"
          fxFlex="100%"
          fxLayout="row"
          fxLayoutAlign="start center"
          *ngIf="displayError(field) && field.dirty && field.touched"
        >
          <mat-icon>error</mat-icon>
          {{ displayError(field) }}
        </p>
      </fieldset>
    </div>
    <div
      fxFlex
      *ngSwitchCase="FieldType.Radio"
      class="radio-group"
      fxLayout="row wrap"
    >
      <fieldset
        fxFlex="100%"
        fxLayout="column"
        role="radiogroup"
        tabindex="0"
        [attr.aria-label]="field.get('name').value + ' group'"
      >
        <legend fxLayoutAlign="start center">
          <mat-icon *ngIf="field.get('icon')">{{
            field.get('icon').value
          }}</mat-icon>
          {{ field.get('name').value }}
          <span aria-hidden="true" [style.color]="'gray'">{{
            field.errors && field.errors?.required && ' *'
          }}</span>
        </legend>

       <div *ngIf="isAdmin">
         <div *ngIf="field.get('name').value==='Panel'">
           <!-- Public panel -->
          <mat-radio-group
          [attr.aria-label]="field.get('name').value"
          fxLayout="row wrap">
          <strong *ngIf="showPanelPublic">Public Network</strong>
          <ng-container *ngIf="!!field && showPanelPublic">
            <mat-radio-button
              [attr.aria-label]="field.get('name').value + ' options'"
              fxFlex="100%"
              *ngFor="
                let option of getOptions(field.get('name').value);
                let i = index
              "
              [value]="option.value"
              [checked]="getSelectedItems(field.get('options'), i)"
              (change)="radioValueChange(field.get('options'), i)"
              [disabled]="false"
              >{{ option.label }} <span *ngIf="option.label==='URL'" class="url-note"> YouTube links only </span>
              </mat-radio-button>
          </ng-container>
        </mat-radio-group>
          <!-- Local Networks Panels -->
          <div *ngFor="let network of networksSelected; let i=index;">
            <strong>{{network.display_value}}</strong>
            <mat-radio-group
            [attr.aria-label]="network.display_value"
            fxLayout="row wrap"
          >
              <mat-radio-button
                [attr.aria-label]="network.display_value + ' options'"
                fxFlex="100%"
                *ngFor="
                  let option of getOptionsPanel(network.display_value)
                  let i = index
                "
                [value]="option.value"
                [checked]="getSelectedItemsPanels(network.id, i)"
                (change)="radioValueChangePanels(network.id, i)"
                >{{ option.label }} <span *ngIf="option.label==='URL'" class="url-note"> YouTube links only </span>
                </mat-radio-button>
          </mat-radio-group>

          </div>
         </div>


        <div *ngIf="field.get('name').value!='Panel'">
          <mat-radio-group
          [attr.aria-label]="field.get('name').value"
          fxLayout="row wrap"
        >
          <ng-container *ngIf="!!field && !field.errors">
            <mat-radio-button
              [attr.aria-label]="field.get('name').value + ' options'"
              fxFlex="100%"
              *ngFor="
                let option of getOptions(field.get('name').value);
                let i = index
              "
              [value]="option.value"
              [checked]="getSelectedItems(field.get('options'), i)"
              (change)="radioValueChange(field.get('options'), i)"
              [disabled]="false"
              >{{ option.label }} <span *ngIf="option.label==='URL'" class="url-note"> YouTube links only </span>
              </mat-radio-button
            >
          </ng-container>
          <ng-container *ngIf="field.errors && field.errors?.required">
            <mat-radio-button
              required
              [attr.aria-label]="field.get('name').value + ' options'"
              fxFlex="100%"
              *ngFor="
                let option of getOptions(field.get('name').value);
                let i = index
              "
              [value]="option.value"
              [checked]="getSelectedItems(field.get('options'), i)"
              (change)="radioValueChange(field.get('options'), i)"
              >{{ option.label }}</mat-radio-button
            >
          </ng-container>
        </mat-radio-group>
        </div>
       </div>

        <div *ngIf="!isAdmin">
          <mat-radio-group
          [attr.aria-label]="field.get('name').value"
          fxLayout="row wrap"
        >
          <ng-container *ngIf="!!field && !field.errors">
            <mat-radio-button
              [attr.aria-label]="field.get('name').value + ' options'"
              fxFlex="100%"
              *ngFor="
                let option of getOptions(field.get('name').value);
                let i = index
              "
              [value]="option.value"
              [checked]="getSelectedItems(field.get('options'), i)"
              (change)="radioValueChange(field.get('options'), i)"
              >{{ option.label }} <span *ngIf="option.label==='URL'" class="url-note"> YouTube links only </span>
              </mat-radio-button
            >
          </ng-container>
          <ng-container *ngIf="field.errors && field.errors?.required">
            <mat-radio-button
              required
              [attr.aria-label]="field.get('name').value + ' options'"
              fxFlex="100%"
              *ngFor="
                let option of getOptions(field.get('name').value);
                let i = index
              "
              [value]="option.value"
              [checked]="getSelectedItems(field.get('options'), i)"
              (change)="radioValueChange(field.get('options'), i)"
              >{{ option.label }}</mat-radio-button
            >
          </ng-container>
        </mat-radio-group>
        </div>


        <p
          class="errors"
          fxFlex="100%"
          fxLayout="row"
          fxLayoutAlign="start center"
          *ngIf="displayError(field) && field.dirty && field.touched"
        >
          <mat-icon>error</mat-icon>
          {{ displayError(field) }}
        </p>
      </fieldset>
    </div>
    <portal-date-picker
      *ngSwitchCase="FieldType.Date"
      [form]="field"
      controlName="value"
      [label]="field.get('name').value"
      [placeholder]="field.get('placeholder')?.value || field.get('name').value"
      [icon]="field.get('icon').value"
      [customErrors]="customErrors"
    >
    </portal-date-picker>
    <div
      *ngSwitchDefault
      fxLayout="row"
      fxLayoutAlign="center center"
      [formGroup]="field"
    >
      <div
        fxFlex
        class="checkbox-group"
        fxLayout="row wrap"
        *ngIf="field.get('field_type').value === -1"
      >
        <label fxFlex="100%"
          >{{ field.get('name').value }}
          <span aria-hidden="true" [style.color]="'gray'"> * </span></label
        >
        <mat-icon *ngIf="field.get('icon')">{{
          field.get('icon').value
        }}</mat-icon>
        <div fxLayout="row wrap" fxFlex>
          <mat-checkbox
            required
            [attr.aria-label]="field.get('name').value + ' options'"
            fxFlex="100%"
            *ngFor="
              let option of getOptions(field.get('name').value);
              let i = index
            "
            [checked]="getSelectedItems(field.get('options'), i)"
            (change)="checkboxValueChange($event, field, i, true)"
          >
            I have agreed by the
            <a target="_blank" routerLink="/guidelines">terms and conditions</a> of the
            Guidelines.
          </mat-checkbox>
        </div>
      </div>
      <ngx-recaptcha2
        *ngIf="field.get('field_type').value === -2"
        [siteKey]="siteKey"
        formControlName="value"
        aria-label="captcha"
      ></ngx-recaptcha2>
    </div>
  </div>
  <span
    class="NetworkHint"
      fxFlex="100%"
      fxLayout="row"
      *ngIf="field.get('name').value == 'Network'">
      Select the networks on which you�d like your ad to appear. You can select more than one network.
    </span>
    <span
    class="NetworkHint"
      fxFlex="100%"
      fxLayout="row"
      *ngIf="field.get('name').value == 'Ad Type'">
      Ads are events if they have a finite event date such as a concert.
    </span>

</ng-template>
